import React, { useState, useCallback } from "react"
import { ButtonField, InputField, CheckboxField, SelectField, Multiselect, SearchSuggestionsWrapper } from '@wk/components-react16';

import { Formik, Form } from 'formik';
import * as yup from 'yup';
import { API_USER } from '../../core/constants';
import Api from '../../core/api';
import { logUserActivity, Toast, UserActivity } from "../../services"
import useDebounce from "../../hooks/useDebounce";

const EditUser = ({ roleList }: any) => {
    const { debounce } = useDebounce();
    let initialObj: any = { username: "", password: "", active: "" };
    const [initialValues, setInitialValues] = useState({ username: "", password: "", active: "" });
    const [resetPassword, setResetPassword] = useState(false);
    const [searchText, setSearchText] = useState('Aaaa');

    const [id, setId] = useState(0);
    const suggestionList: any = [
        {
            id: "userlist",
            type: "suggestions",
            title: "User suggestions",
            hasIcon: true,
            suggestions: []
        }
    ]
    const [suggestionUserList, setSuggestionUserList] = useState(suggestionList)

    const Schema = yup.object().shape({
        username: yup
            .string(),
        password: yup
            .string()
            .trim()
            .min(8, 'Password must be 8 characters long')
            .matches(/[0-9]/, 'Password must contain at least one number')
            .matches(/[a-z]/, 'Password must contain at least lowercase letter')
            .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
            .matches(/[^\w]/, 'Password must contain at least one special character'),
        active: yup.string(),
    });

    const getUser = (u: any) => {
        Api.getRequest(`${API_USER.GET_USERBYID}?id=${u.uId}`).then(
            (res: any) => {
                if (res) {
                    roleList.forEach((item: any) => {
                        item.isSelected = res.roles.some(
                            (itm: any) => itm.name.toUpperCase() === item.name.toUpperCase()
                        );
                    });
                    initialObj = { username: res.username, password: "", active: res.active ? "active" : "inactive" };
                    setInitialValues(initialObj);
                    setId(res.id)
                }
            },
            (err: any) => {
                Toast(err.message, "error")
            },
        )
    }

    const getSuggestion = (text: string) => {
        setSuggestionUserList([])
        let payload = {
            username: text
        }
        Api.postRequest(API_USER.SEARCHUSER, payload).then(
            (res: any) => {
                suggestionList[0].suggestions = res.map((itm: any, index: any) => ({ id: index, text: itm.username, uId: itm.id }));
                setSuggestionUserList(suggestionList);
            },
            (err: any) => {
                Toast(err.message, "error")
            },
        )
    }

    //const getUserSuggestion = useCallback(debounce((val: string) => userSuggestion(val), 400), []);
    const userSuggestion = useCallback(debounce(getSuggestion, 400), []);

    const getUserSuggestion = (text: string) => {
        if (text === '') return;
        userSuggestion(text)
    }

    const submit = async (values: any) => {
        if (values.username.trim() === '') {
            Toast("Please select username", "error")
            return;
        }
        if (resetPassword) {
            let regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/;
            if (!regex.test(values.password.trim())) {
                Toast("Password must be 8+ chars, with 1 digit, 1 lowercase, 1 uppercase, and 1 special character", "error")
                return;
            }
        }
        if (roleList.filter((item: any) => item.isSelected).length === 0) {
            Toast("Please select atleast one role.", "error")
            return;
        }
        if (values.active === '') {
            Toast("Please select the status", "error")
            return;
        }
        values['roles'] = roleList.filter((item: any) => item.isSelected).map((item: any) => item.id);
        values.active = values.active === 'active' ? true : false;
        values.password = values.password.trim();
        values['id'] = id;
        if (!resetPassword) delete values["password"];
        let userActivity: UserActivity = {
            action: 'Update User Button Click',
            page: 'User Management',
            viewName: 'Edit User',
            entityName: values.username
        }
        logUserActivity(userActivity);
        Api.postRequest(API_USER.UPDATE_USER, values).then(
            (res: any) => {
                if (res.status === 200) Toast("User updated successfully.", "sucsess")
                else Toast(res.message, "sucsess")
                clearForm();
            },
            (err: any) => {
                Toast(err.message, "error")
            },
        )
    }

    const clearForm = () => {
        setInitialValues({ username: "", password: "", active: "" })
        setId(0)
        setSuggestionUserList([]);
        roleList.forEach((item: any) => item.isSelected = false);
        setResetPassword(false);
        setSearchText('')
    }

    return (
        <>
            <div className="wk-row">
                <div className="wk-col-6 relative" id="search-suggestion">
                    <SearchSuggestionsWrapper onInputChange={getUserSuggestion}
                        onItemSelected={getUser} options={suggestionUserList} size="small" isSearchEnabledOnEmptyInput={false}
                        value={searchText} placeholder="Search by email id">
                    </SearchSuggestionsWrapper >
                </div>
                <div className="wk-col-3">
                    <ButtonField size={'small'}>
                        <button type="button" style={{ marginRight: '5px' }} onClick={clearForm}>
                            Clear
                        </button>
                    </ButtonField>
                </div>
            </div >
            <hr className="mb-10" />
            <Formik
                validationSchema={Schema}
                enableReinitialize={true}
                initialValues={initialValues}
                onSubmit={submit}
            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isValid,
                    dirty }) => (
                    <Form onSubmit={handleSubmit}>
                        <div className="wk-row">
                            <div className="wk-col-6">
                                <InputField
                                    label="Email ID"
                                    labelFor="username-2"
                                    size="small" indicator="required">
                                    <input
                                        type="text"
                                        id="username-2"
                                        name="username"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.username}
                                        readOnly
                                        disabled
                                    />
                                </InputField>
                                <CheckboxField label="Reset Password">
                                    <input
                                        name="checkbox"
                                        type="checkbox"
                                        checked={!!resetPassword}
                                        onChange={(e: any) => {
                                            setResetPassword(!!e.target.checked)
                                            if (!e.target.checked) {
                                                values.password = "";
                                            }
                                        }}
                                    />
                                </CheckboxField>
                                <InputField
                                    label="Password"
                                    labelFor="password-3"
                                    size="small" indicator="required"
                                    status={!!errors.password && resetPassword ? "error" : "none"}
                                    errors={!!errors.password && resetPassword ? [{
                                        label: errors.password,
                                        labelId: 'label-error-id-3',
                                    }] : []}
                                >
                                    <input
                                        type="password"
                                        id="password-3"
                                        name="password"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.password}
                                        readOnly={!resetPassword}
                                        placeholder="Enter password"
                                        autoComplete="off"
                                    />
                                </InputField>
                            </div>
                            <div className="wk-col-6">
                                <Multiselect
                                    items={roleList}
                                    pillLabel="Roles selected"
                                    placeholder="Choose Role"
                                    size="small"
                                    label="Role"></Multiselect>
                                <SelectField
                                    label="Status"
                                    labelFor="select-id-2"
                                    size="small">
                                    <select id="select-id-2" name="active" value={values.active} onChange={handleChange}>
                                        <option value="" disabled>Select status</option>
                                        <option value="active">Active</option>
                                        <option value="inactive">Inactive</option>
                                    </select>
                                </SelectField>
                            </div>
                        </div>
                        <div className="wk-row">
                            <div className="wk-col-12 text-right">
                                <ButtonField size={'small'}>
                                    <button type="submit" disabled={!(isValid)}>
                                        Update User
                                    </button>
                                </ButtonField>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default EditUser;
